/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { useState } from "react";

import ReactQuill from "react-quill-new";

import PaperBox from "../PaperBox/PaperBox";
// since the package does not have .map files and throws warning:
// Failed to parse source map from '/Users/laurapociuniene/projects/work/tacho-front-end/node_modules/react-quill-new/dist/quill.snow.css.map'
//  css file is customised and imported directly
import "./styles/customReactQuillNewStyle.css";

import { useStyles } from "./styles/styles";

interface RichTextFieldProps {
  label: string;
  isRichTextFocused: boolean;
  richTextInputError: string | null;
  richTextValue: string;
  handleChangeRichTextValue: (value: string) => void;
  validateRichTextLength: (value: any, fromOnBlur?: boolean) => void;
  handleFocus: () => void;
  testId?: string;
  edit?: boolean;
  isLoading?: boolean;
}

const RichTextField = ({
  label,
  isRichTextFocused,
  richTextInputError,
  richTextValue,
  handleChangeRichTextValue,
  validateRichTextLength,
  handleFocus,
  testId,
  edit = false,
  isLoading
}: RichTextFieldProps) => {
  const [preventOnChange, setPreventOnChange] = useState(edit);

  const { richTextFieldContainer } = useStyles({
    isRichTextFocused,
    richTextInputError
  });

  const handleKeyDown = () => {
    setPreventOnChange(false);
  };

  return (
    <PaperBox
      testId={testId ?? "rich-text-field"}
      boxTitle={label}
      customStyling={richTextFieldContainer}
      errorText={richTextInputError}
    >
      <ReactQuill
        theme="snow"
        value={richTextValue}
        onChange={(value: string, _, source: any) =>
          source !== "api" &&
          !preventOnChange &&
          handleChangeRichTextValue(value)
        }
        onBlur={() => validateRichTextLength(richTextValue, true)}
        onFocus={handleFocus}
        onKeyDown={handleKeyDown}
        bounds=".paper-box" // bounds to prevent quill toolbar from going outside the box
        // override styles does not work in this case when moved to separate file
        css={css({
          minHeight: "110px",
          ".ql-toolbar.ql-snow": {
            border: "none",
            ".ql-clean": { display: "none" }
          },
          ".ql-container.ql-snow": { border: "none" }
        })}
        readOnly={isLoading}
      />
    </PaperBox>
  );
};

export default RichTextField;
